module.exports = __webpack_public_path__ + "static/media/Background_4.2bcd66e1.svg";